import React, { Component } from 'react';
import {connect} from "react-redux";
import {Link} from "react-router-dom";

import { lang } from '../../config/lang';

/****************************************
    Component for TitleBar of content
    @author  IMH003
    @date    2019.7.5
    @version 0.1    
 ******************************************/
class NotFound extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        
    }
  
    componentWillMount() {
                  
        
    }

    componentWillReceiveProps(newProps) {
        
        
    }

    render() {
        var pathname = this.props.location.pathname;

          return (
            <div className="page-404-3">
                <div className="container error-404">
                    
                    <h1>404</h1>                
                    
                    <h2>{lang('we_have_err')}</h2>
                    
                    <p>
                        {lang('not_exist_path')}
                    </p>
                    {
                        pathname.slice(pathname.length-4, pathname.length) !== ".mp4" &&
                        <Link to="/home">
                            {lang('return_home')}
                        </Link>
                    }
                </div>                
            </div>
        );
    }
}

function mapStateToProps(state) {    
    return { 
      language: state.language,
    };
}

NotFound = connect(mapStateToProps)(NotFound)
export default NotFound;